import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const circleci = defineConnector({
  identifier: "circleci",
  name: "CircleCI",
  tagLine: "CI/CD platform",
  keywords:
    "circle ci cd continuous integration delivery pipelines builds workflows jobs",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://circleci\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Circle-Token", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Get your CircleCI API token",
      items: [
        {
          kind: "markdown",
          content:
            "In CircleCI, go to **User Settings > Personal API Tokens** and create a new token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Personal API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://circleci.com/api/v2/me",
  },
});
